module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAJCAYAAAD6reaeAAAAWklEQVQYV2P8//+/MQMDwz1GRsb3QBoMGIGCaUAahF1hEowgGaDETCAF0gGWAAtiSCAJCgLZd4G4E6YdJLAbiM8CtafDBEECIBekw2wvBzKUYAIwQUFkN4IEAUriKYwyZI0bAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/dropdown-arrow.png
// module id = 651
// module chunks = 0